import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";  // Corrected import
import { APP_ENV } from "../utils/config";
import rootReducer from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),  // Use a callback function to add custom middleware
  devTools: APP_ENV === "development",
});

export default store;
